import axios from "axios";

export default axios.create({
    // baseURL: "https://api.terganeteranga.com/api/"
    baseURL: "https://api.terganeteranga.carreemarketing.com/api/"
    // baseURL: "http://localhost:8000/api/"
    // baseURL: "https://api.eden-invest.carreemarketing.com/api/"
    // baseURL: process.env.NODE_ENV === "production" ? 
    // "https://api.eden-invest.carreemarketing.com/api/" :
    // "http://localhost:8000/api/",
  
          // withCredentials: true,
          // headers: {
          //   Accept: "*/*",
          //   "Content-Type": "application/json",
          //   "Access-Control-Allow-Origin" : 'http://127.0.0.1:3000'
          // },
});
